<template>
    <aside class="wizard-panel" :class="{ 'is-open': status === 1, 'is-full': status === 2 }" :style="style">
        <button type="button" class="wizard-panel__close" @click="back">
            <icon-base viewBox="0 0 12 10"><icon-double-arrow-right /></icon-base>
        </button>

        <slot></slot>
    </aside>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        status: {
            type: Number,
            default: 0
        },
        forceFull: {
            type: Boolean,
            default: false
        },
        style: {
          type: Object,
          default: {}
        }
    },
    computed: {
        ...mapState('common', ['panels']),
        elPanels() {
            return new Proxy(this.panels, {
                set: (target, prop, value) => {
                    this.TOGGLE_PANEL({ [prop]: value });

                    return true;
                },
            });
        }
    },
    methods: {
        ...mapMutations('common', ['TOGGLE_PANEL']),
        back() {
            this.forceFull ? this.elPanels[this.name] = 0 : this.elPanels[this.name] = this.elPanels[this.name] - 1;
        },
        closePanel(e) {
            if (e.target.closest('.dialog')?.classList.contains('dialog')) {
                return;
            }
            
            if (!this.$el.contains(e.target) && this.elPanels[this.name] > 0) {
                this.elPanels[this.name] = 0;
            }
        },
    },
    watch: {
        status: function (newValue, oldValue) {
            // Коллбэк на открытие панели
            if (newValue === 1 && oldValue === 0) {
                this.$emit('open');
            }

            // ScrollTop колонок в 0
            if ((newValue === 0 && oldValue === 1)
                || (newValue === 2 && oldValue === 1)
            ) {
                const columns = this.$el.querySelectorAll('.js-wizard-panel-column');

                columns && [...columns].forEach((item) => {
                    item.scrollTop = 0;
                });
            }

            // Коллбэк на закрытие панели
            if (newValue === 0 && oldValue === 1 || newValue === 0 && oldValue === 2) {
                this.$emit('close');
            }
        }
    },
    mounted() {
        // document.addEventListener('click', this.closePanel);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closePanel);
    }
};
</script>
